module.exports = "/images/clubspeed.svg?1e89a08bf09a6247078e3253a49901a5";